export default __webpack_public_path__ + "static/media/57.eb752807.jpg";